import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import { localBusinessSchema } from "@/data/localBusinessSchema";
import Index from "@/pages/Index";

export const Route = createFileRoute("/_site/")({
  head: () => ({
    ...seo({
      title: "Kodiak Structures & Exteriors | Roofing & Siding Contractor",
      path: "/",
    }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(localBusinessSchema),
      },
    ],
  }),
  component: Index,
});
